export default "__VITE_ASSET__DGZxHfS$__"